// languageSlice.js
import { createSlice } from '@reduxjs/toolkit';
import i18n from '../../../src/i18n'; // Adjust the import path as necessary
import { getStoredAppLanguage } from '@/utils/getStoredAppLanguage';

const languageSlice = createSlice({
  name: 'language',
  initialState: getStoredAppLanguage(),
  reducers: {
    switchLanguage: (state, action) => {
      const newLang = action.payload;
      i18n.changeLanguage(newLang); // update i18n language
      return newLang;
    },
  },
});

export const { switchLanguage } = languageSlice.actions;
export default languageSlice.reducer;
